import {
  GET_LEAD_CAPTURE,
  GET_LEAD_CAPTURE_SUCCESS,
  GET_LEAD_CAPTURE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getLeadCaptureReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAD_CAPTURE:
      return { ...state, loading: true };
    case GET_LEAD_CAPTURE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_LEAD_CAPTURE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getLeadCaptureReducer;
